import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { View } from 'react-native';
import { Popup } from '../../Popup/rn';
import { Message } from '../../Message/rn';
import { ButtonGroup } from '../../ButtonGroup/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { FONT_WEIGHT_MEDIUM } from '../../../styles/rn';
export var Cascader = function Cascader(props) {
  var _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles,
    content = props.content,
    buttonGroup = props.buttonGroup,
    popupProps = props.popupProps,
    _props$titleTextStyle = props.titleTextStyles,
    titleTextStyles = _props$titleTextStyle === void 0 ? {} : _props$titleTextStyle,
    isUIOptimisationRecommender = props.isUIOptimisationRecommender;
  return /*#__PURE__*/React.createElement(View, {
    style: styles
  }, /*#__PURE__*/React.createElement(Message, {
    styles: {
      containerStyle: [{
        borderRadius: 4
      }, styles],
      textStyle: _objectSpread(_objectSpread({}, FONT_WEIGHT_MEDIUM), {}, {
        fontSize: 40,
        padding: 12
      }, titleTextStyles) // ...FONT_WEIGHT_MEDIUM 对于content为不包含标签的字符串时，不生效
    },

    className: 'cascader-message-content',
    content: content,
    buttonGroup: buttonGroup,
    isUIOptimisationRecommender: isUIOptimisationRecommender,
    useSimpleRichText: true
  }), /*#__PURE__*/React.createElement(Popup, {
    showCloseIcon: true,
    active: popupProps.show,
    title: popupProps.title,
    titleStyle: style['modal-cascader-title'],
    contentStyle: {
      padding: 0
    },
    contentContainerStyle: style['modal-cascader-content'],
    onClose: popupProps.onClose
  }, /*#__PURE__*/React.createElement(ButtonGroup, _extends({
    styles: [style['modal-cascader-content-buttons'], styles]
  }, popupProps))));
};
var style = CustomStyleSheet({
  'modal-cascader-title': {
    backgroundColor: '#ffffff',
    textAlign: 'center',
    paddingTop: 14,
    paddingRight: 14,
    paddingBottom: 14,
    paddingLeft: 14
  },
  'modal-cascader-content': {
    backgroundColor: '#efefef'
  },
  'modal-cascader-content-buttons': {
    backgroundColor: '#ffffff',
    marginTop: 12,
    marginRight: 0,
    marginBottom: 12,
    marginLeft: 0
  }
});